import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";
import SimpleBar from "simplebar-react";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import { getActivityLabel } from "../../helpers/activityLabel";

const RecentActivity = ({ t, recentActivity = {}, degraded = false }) => {
    const dateUtils = new DateUtils();
    const items = recentActivity.items || [];

    return (
        <Card className="mb-0">
            <CardBody>
                <CardTitle className="overview-section-title mb-4">
                    {t("Recent Activity")}
                </CardTitle>
                {degraded || !items.length ? (
                    <p className="text-muted mb-0">
                        {t("No recent activity.")}
                    </p>
                ) : (
                    <SimpleBar style={{ height: "318px" }}>
                        <ul className="list-unstyled activity-wid">
                            {items.map((activity) => (
                                <li
                                    key={activity.id}
                                    className="activity-list"
                                >
                                    <div className="activity-icon avatar-xs">
                                        <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                            <i className="ri-edit-2-fill" />
                                        </span>
                                    </div>
                                    <div>
                                        <h5 className="font-size-13">
                                            {dateUtils.convertDateToDate(
                                                activity.occurredAt,
                                                INTERNATIONAL_DATE_FORMAT
                                            )}
                                            <small className="ml-3 text-muted">
                                                {" "}
                                                {dateUtils.convertDateToDate(
                                                    activity.occurredAt,
                                                    "HH:mm"
                                                )}
                                            </small>
                                        </h5>
                                        <p className="text-muted mb-0">
                                            {t(getActivityLabel(activity))}
                                            {activity.actor?.displayName
                                                ? ` ${t("by")} ${
                                                    activity.actor.displayName
                                                }`
                                                : ""}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </SimpleBar>
                )}
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(RecentActivity);
